module.exports = __webpack_public_path__ + "img/brand-ibm.69bcd13f.svg";